import { ListeCarteImageNomContext } from '@components/liste-carte-image-nom/models';
import { environment } from '@environments/environment';

export const GET_FINITIONS_QUERY = (langcode: string, context: ListeCarteImageNomContext) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_finitions,
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:taxonomy_term',
            },
          },
          {
            term: {
              vid: 'type_de_produit',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              field_categorie_produit: context,
            },
          },
        ],
      },
    },
    _source: ['name', 'field_visuel', 'field_page_link'],
  },
});
